import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import SEOSection from './components/SEOSection';
import FeatureGrid from './components/FeatureGrid';
import TestimonialSection from './components/TestimonialSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <CTASection />
        <SEOSection />
        <FeatureGrid />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}